<template>
  <page-layout class="live_events">
    
    <display-container :section="711" :no-auto-link="true" class="title">
      <template v-slot="{ component, row }">
        <div class="title_top">
          <p>{{component.getTitle(row)}}</p>
        </div>
      </template>
    </display-container>

    <article class="inner">

      <div class="contents_wrap">

        <!-- 진행중 이벤트 -->
        <div class="events" v-if="getIsOngoing">
          <h3>Ongoing</h3>

          <div class="event_ctnr" v-for="event in liveEvents.ongoing" :key="event.idx">
            <p>
              <img :src="getImage(event)" v-if="!event.link_url" />
              <router-link :to="event.link_url" v-else-if="event.link_target === '_self'"><img :src="getImage(event)" /><span class="btn">View Related Articles</span></router-link>
              <a :href="event.link_url" :target="event.link_target" v-else><img :src="getImage(event)" /></a>
            </p>
            <div class="reports" v-for="reporting in event.live_reporting" :key="reporting.idx">
              <router-link class="report_ctnr" :to="`/live/reporting/${reporting.idx}`" v-if="event.is_live_reporting">
                <!--<span class="img"><img src="/statics/img/bi.png"></span>-->
                <em>LIVE</em>
                <span>Live Reporting : </span>
                <i>{{ reporting.title }}</i>
                <span class="btn">go</span>
              </router-link>
            </div>
          </div>

        </div>

        <!-- 예정 이벤트 -->
        <div class="events" v-if="getIsUpcoming">
          <h3>Upcoming</h3>

          <div class="event_ctnr" v-for="event in liveEvents.upcoming" :key="event.idx">
            <p>
              <img :src="getImage(event)" v-if="!event.link_url" />
              <router-link :to="event.link_url" v-else-if="event.link_target === '_self'"><img :src="getImage(event)" /><span class="btn">View Related Articles</span></router-link>
              <a :href="event.link_url" :target="event.link_target" v-else><img :src="getImage(event)" /></a>
            </p>
          </div>

        </div>

        <!-- 지난 이벤트 -->
        <div class="events" v-if="getIsPast">
          <h3>Past Events</h3>

          <div class="event_ctnr past" v-for="event in liveEvents.past" :key="event.idx">
            <p>
              <img :src="getImage(event)" v-if="!event.link_url" />
              <router-link :to="event.link_url" v-else-if="event.link_target === '_self'"><img :src="getImage(event)" /><span class="btn">View Related Articles</span></router-link>
              <a :href="event.link_url" :target="event.link_target" v-else><img :src="getImage(event)" /></a>
            </p>
            <div class="reports" v-for="reporting in event.live_reporting" :key="reporting.idx">
              <router-link :to="`/live/reporting/${reporting.idx}`" class="report_ctnr">
                <em>FINISHED</em>
                <span>Live Reporting : </span>
                <i>{{ reporting.title }}</i>
                <span class="btn">go</span>
              </router-link>
            </div>
          </div>

        </div>

      </div>

    </article>


  </page-layout>
</template>

<script>
	import Vue from 'vue'
  import {Dialog, Popover} from 'element-ui'
  import {QDialog, QBtn, QBtnGroup, Loading, QSlideTransition, QDate, QCard, QSeparator} from 'quasar'
  import SubPageLayout from '../layouts/SubPageLayout'
  import DisplayContainer from '../components/DisplayContainer'
  import CommonComputed from 'src/_mixins/CommonComputed'
  import CommonMethods from 'src/_mixins/CommonMethods'
  import PageLayout from '../layouts/PageLayout'
  export default {
    name: "Events",
    components: {
      SubPageLayout,
      PageLayout,
      DisplayContainer,
      QDialog, QBtn, QBtnGroup, QCard, QDate, QSeparator,
      [Dialog.name]: Dialog,
      [Popover.name]: Popover,
      Loading,
      QSlideTransition,
    },
    metaInfo () {
      return {
        title: `${this.getAppName} | Live Events`,
        titleTemplate: '%s',
        meta: [
          {vmid: 'description', name: 'description', content: `Poker Live Updates and stories from tournaments`},
          {vmid: 'image', name: 'image', content: '/statics/seo/seo_main.jpg'},
          {vmid: 'og:title', property: 'og:title', content: `Live Events | ${this.getAppName}`},
          {vmid: 'og:description', property: 'og:description', content: `Poker Live Updates and stories from tournaments`},
          {vmid: 'og:image', property: 'og:image', content: '/statics/seo/seo_main.jpg'}
        ]
      }
    },
    data () {
      return {
        liveEvents: {
          upcoming: [],
          ongoing: [],
          past: []
        },
      }
    },
    mounted() {
      this.getLiveEvents()
    },
    computed: {
      ...CommonComputed,
      getAccess () {
        return 'pc'
      },
      getIsUpcoming () {
        return this.liveEvents.upcoming.length > 0
      },
      getIsOngoing () {
        return this.liveEvents.ongoing.length > 0
      },
      getIsPast () {
        return this.liveEvents.past.length > 0
      }
    },
		methods: {
      ...CommonMethods,
      getLiveEvents () {
        this.axios.get('/live/events').then(rs => {
          this.liveEvents = rs.data
        })
      },
      getImage (event) {
        return this.getFileExist(event[`${this.getAccess}_img`])
      },
    }
  }
</script>

<style scoped>
  .live_events {
    position: relative;
    top: -40px;
  }
  .display-container.title {
    background: url(/statics/img/bg_sub_title.jpg) center no-repeat;
    background-size: cover;
    margin-bottom: 40px;
  }
  .title_top {
    position: relative;
    width: 1220px;
    height: 180px;
    display: flex;
    align-items: center;
    margin: 0 auto;
  }
  .title_top:before {
    content: "";
    display: inline-block;
    width: 54px;
    height: 54px;
    background: url(/statics/img/bi_white.png) center no-repeat;
    background-size: cover;
    margin-right: 15px;
  }
  .title_top p {
    font-family: 'Roboto Slab';
    font-size: 60px;
    font-weight: 900;
    color: #fff;
    line-height: 1.0em;
    text-transform: capitalize;
    z-index: 1;
  }
  .events {
    margin-bottom: 50px;
  }
  .events h3 {
    font-family: 'Roboto Slab';
    font-size: 28px;
    font-weight: 900;
    margin-bottom: 15px;
    letter-spacing: -0.02em;
  }
  .events .event_ctnr {
    margin-bottom: 30px;
  }
  .events .event_ctnr p a {
    position: relative;
    width: 100%;
    height: 100%;
    display: inline-block;
  }

  .events .event_ctnr p a .btn {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    display: inline-block;
    font-size: 16px;
    font-weight: 700;
    color: #00ff64;
    padding: 14px 20px;
    background: rgba(0,0,0,0.85);
    border: 1px solid #00ff64;
    border-radius: 5px;
    z-index: 2;
    transition: .15s;
    opacity: 0;
  }
  .events .event_ctnr p:hover a .btn {
    opacity: 1;
  }
  .events .event_ctnr p img {
    /*filter: brightness(55%) grayscale(25%);*/
    transition: .25s;
  }
  /*.events .event_ctnr.past p a:after {
    content: "";
    position: absolute;
    width: 100%;
    left: 0;
    bottom: 0;
    height: 25px;
    background: linear-gradient(180deg, rgba(0,0,0,0), rgba(0,0,0,1.0));
    z-index: 2;
  }*/
  .events .event_ctnr p:hover img {
    filter: brightness(60%) grayscale(0);
  }

  .events .event_ctnr .reports {
    padding: 5px 20px 0 20px;
    background: #000;
    position: relative;
  }
  .events .event_ctnr .reports:last-child {
    padding-bottom: 20px;
  }
  .events .event_ctnr .reports:nth-child(2):before {
    content: "";
    position: absolute;
    width: 100%;
    height: 25px;
    top: -20px;
    left: 0;
    background: linear-gradient(180deg, rgba(0,0,0,0), rgba(0,0,0,1.0));
    z-index: 2;
  }
  .events .event_ctnr .report_ctnr {
    display: block;
    background: rgba(255,255,255,0.2);
    padding: 24px 20px 24px 160px;
    font-size: 18px;
    font-weight: 500;
    color: #fff;
    letter-spacing: -0.01em;
    position: relative;
    text-align: left;
    border-radius: 5px;
  }
  /*
  .events .event_ctnr .report_ctnr:before {
    content: "go";
    display: inline-block;
    font-weight: 500;
    color: #888;
    position: absolute;
    top: 50%;
    right: 75px;
    transform: translate(0, -50%);
  }
  */
  /*
  .events .event_ctnr .report_ctnr:after {
    content: "";
    display: inline-block;
    width: 12px;
    height: 12px;
    border: solid #000;
    border-width: 3px 3px 0 0;
    position: absolute;
    top: 50%;
    right: 40px;
    transform: rotate(45deg) translate(-50%, 0);
  }*/
  .events .event_ctnr .report_ctnr:after {
    content: "";
    display: inline-block;
    width: 24px;
    height: 24px;
    background: url(/statics/img/a_arrow_v.png) no-repeat;
    background-size: contain;
    position: absolute;
    right: 25px;
    transform: rotate(-90deg);
    filter: hue-rotate(240deg) saturate(900%);
  }
  .events .event_ctnr .report_ctnr .img {
    width: 60px;
    position: absolute;
    transform: translate(-84px, -28px);
  }
  .events .event_ctnr .report_ctnr .img img {
    width: 100%;
    position: relative;
    z-index: 1;
  }
  .events .event_ctnr .report_ctnr .img:after {
    content: "";
    display: inline-block;
    width: 40px;
    height: 40px;
    background: #fff;
    transform: rotate(45deg);
    position: absolute;
    top: -18px;
    left: 10px;
  }
  .events .event_ctnr .report_ctnr em {
    font-weight: 900;
    font-size: 16px;
    color: #fff;
    letter-spacing: 0.07em;
    font-style: italic;
    background: #ff0000;
    padding: 10px 20px;
    margin-right: 30px;
    border-radius: 5px;
    width: 120px;
    display: inline-block;
    text-align: center;
    position: absolute;
    top: 50%;
    left: 20px;
    transform: translate(0, -50%);
  }
  /* .events .event_ctnr .report_ctnr em:before {
    content: "";
    display: inline-block;
    width: 30px;
    height: 30px;
    background: #ff0000;
    transform: rotate(45deg) translate(-65%, 0);
    position: absolute;
    top: 5px;
    left: 50%;
  } */
  .events .event_ctnr .report_ctnr span {
    font-weight: 300;
  }
  .events .event_ctnr .report_ctnr i {
    font-weight: 800;
  }
  .events .event_ctnr .report_ctnr .btn {
    padding: 8px 44px 8px 24px;
    background: #008c03;
    margin-left: 30px;
    font-size: 0.9em;
    font-weight: 500;
    color: #fff;
    border-radius: 0.2em;
    position: relative;
    display: none;
  }
  .events .event_ctnr .report_ctnr .btn:after {
    content: "";
    display: inline-block;
    width: 8px;
    height: 8px;
    border: 2px solid;
    border-width: 2px 2px 0 0;
    transform: rotate(45deg) translate(0, -50%);
    position: absolute;
    top: 50%;
    right: 24px;
  }
  .events .event_ctnr .report_ctnr:hover .btn {
    opacity: 0.8;
  }
  .events .event_ctnr .report_ctnr:hover {
    background: rgba(255,255,255,0.3);
  }
  /*.events .event_ctnr.past p img {
    filter: brightness(55%) grayscale(25%);
  }*/
  .events .event_ctnr.past .report_ctnr:after {
    filter: saturate(900%) brightness(100%);
  }
  .events .event_ctnr.past .report_ctnr em {
    background: #000;
    font-style: normal;
    letter-spacing: 0.02em;
    /*color: #00ff64;*/
    color: #fff;
  }
  .events .event_ctnr.past .report_ctnr em:before {
    background: #292929;
  }
</style>
